export default __webpack_public_path__ + "static/media/foto-perfil.203d1806.jpeg";